import { FC } from "react";
import "./Cookies.scss";

import { Box, Text, Link } from "@chakra-ui/react";

interface cookiesProps {
  consentToAllCookies: any;
}

const Cookies: FC<cookiesProps> = (props) => {
  return (
    // <Box className="cookie-wrap" style="display: block;">
    <Box className="cookie-wrap">
      <Box className="cookie-inner-wrap">
        <Text className="cookie-text">
          The website uses cookies for a variety of purposes. Some are essential for the operation of online services.
          However, cookies for analytics and your settings provide a better user experience, easier site usage. You can
          read more about cookies in{" "}
          <Link target="_blank" href="/privacy#cookies">
            Cookies
          </Link>
          . By continuing to use the site you agree to the cookies. You can edit your cookie{" "}
          <Link target="_blank" href="/privacy#cookies">
            settings here
          </Link>
          .
        </Text>
        <button className="cookie-btn" onClick={props.consentToAllCookies}>
          OK
        </button>
        {/* <button className="cookie-btn" onclick="consentToAllCookies()">OK</button> */}
      </Box>
    </Box>

    // <Flex justify={'space-between'} bg='#D93F0B' p={4} w="100%" color="white">
    //   <Heading as='h1' noOfLines={1}>
    //     Hi, welcome to the site!
    //   </Heading>
    //   <MetamaskButton onAccountChange={props.onAccountChange} />
    // </Flex>
  );
};

export default Cookies;
